import React from "react"
import Slider from "react-slick"
import styled from "styled-components"
const NumbersHorizantal = ({ children }) => {
  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    )
  }
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    nextArrow: <SampleNextArrow className="next" />,
    prevArrow: <SamplePrevArrow />,
  }
  return (
    <Wraper>
      <Slider {...settings}>{children}</Slider>
    </Wraper>
  )
}

export default NumbersHorizantal

const Wraper = styled.div`
  max-width: 95%;
  .slick-prev:before,
  .slick-next:before {
    color: #656565;
  }
  .slick-next {
    top: -2%;
    right: 45% !important;
    transform: rotate(-90deg);
  }
  .slick-prev {
    bottom: 0 !important;
    top: 100%;
    left: 45% !important;
    transform: rotate(-90deg);
  }
`
